import React from "react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { ArrowRight, Heart, House, MapPin, Users } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const impactItems = [{
  title: "Neighborhood Revitalization",
  description: "Transforming neglected properties into safe, welcoming homes that uplift the entire street and improve local property values in Abilene.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/abilene_neighborhood_revitalization.png",
  icon: House
}, {
  title: "Community Connection",
  description: "Creating common areas and shared spaces that encourage interaction, turning neighbors into friends and housing into true communities.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/community_gathering_courtyard.png",
  icon: Users
}, {
  title: "Sustainable Living",
  description: "Implementing energy-efficient upgrades and responsible maintenance practices to reduce our environmental footprint across Texas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/sustainable_home_upgrades.png",
  icon: Heart
}, {
  title: "Local Heritage",
  description: "Preserving the unique architectural character of Abilene while modernizing interiors for today's comfort and lifestyle needs.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553193/img/abilene_historic_architecture.png",
  icon: MapPin
}];
export default function CommunityImpact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}